import { render } from "./SettingsPointOfSale.vue?vue&type=template&id=469548e6"
import script from "./SettingsPointOfSale.vue?vue&type=script&lang=js"
export * from "./SettingsPointOfSale.vue?vue&type=script&lang=js"

import "./SettingsPointOfSale.vue?vue&type=style&index=0&id=469548e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__